export const hexToRgba = (hex: string, opacity = 1): string => {
  // Check if input is already in rgba format
  if (/^rgba?\(/i.test(hex)) {
    return hex;
  }

  // Trimmed, not just un-hashed: `parseInt(' #ffffff', 16)` is NaN, and `NaN >> 16` is 0, so a value
  // with stray whitespace used to come back as opaque black. Shop colours arrive here from
  // `setPaulyCustomTheme`, where that silently blacks out the shop's palette.
  hex = hex.trim().replace(/^#/, '');

  // Support short form (#abc)
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('');
  }

  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
